<template>
  <div>
    <modules
      :moduleType="moduleType"
      @currentModuleIdChanged="currentModuleIdChanged"
      :hasTerminal="true"
      :hasAdd="authority.IsAdd"
      :hasEdit="authority.IsUpdate"
      :hasRemove="authority.IsRemove"
    >
      <template slot="buttons">
        <button
          type="button"
          class="btn btn-outline-primary btn-icon py-2 px-4"
          v-if="authority.IsUpdate"
          @click="functionClick"
        >
          <i class="fa fa-mouse-pointer"></i>
        </button>
      </template>
    </modules>

    <router-view />
  </div>
</template>

<script>
import modules from "@/components/modules/Modules";

export default {
  data() {
    return {
      moduleType: 3,
      currentModuleId: "",
      authority: {},
    };
  },
  components: {
    modules,
  },
  methods: {
    isSelected() {
      if (this.currentModuleId && this.currentModuleId.length > 0) {
        return true;
      } else {
        this.$func.message.alert("請選擇一筆模組 !");
        return false;
      }
    },
    currentModuleIdChanged(id) {
      this.currentModuleId = id;
    },
    terminalClick() {
      if (!this.isSelected()) {
        return;
      }
      this.$router.push({
        name: "TerminalFunction",
        params: { id: this.currentModuleId },
      });
    },
    functionClick() {
      if (!this.isSelected()) {
        return;
      }
      this.$router.push({
        name: "FunctionButton",
        params: { id: this.currentModuleId },
      });
    },
  },
  created() {
    this.authority = this.$func.localStorage.getAuthByName(this.$route.name);
  },
};
</script>
